import React from 'react';
import { useNavigate } from 'react-router-dom';
import C from '../colors';

const Logo = ({ logo, home }) => {
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate(home)} style={{ width: '100%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
      {logo && (
        <img src={logo} alt="图派" style={{ width: 68, height: 68, objectFit: 'contain' }}/>
      )}
      <span style={{ fontFamily: C.serif, fontSize: 26, color: C.ink }}>图派</span>
      <div style={{ marginLeft: 5, marginTop: -8, color: '#fff', background: C.brand, height: 15, width: 32, textAlign: 'center', lineHeight: '15px', fontSize: 9, borderRadius: 5 }}>PRO</div>
    </div>
  );
};
export default Logo;
